import React from "react";
import { FiCheckCircle } from "react-icons/fi";
import "./AIJobOfferSection.css"; // same design system

const AIShareJobSection = () => {
  return (
    <div className="aios-wrapper">
      <div className="aios-container">

        {/* LEFT SIDE IMAGE (CARD BOX) */}
        <div className="aios-image-card">
          <div className="aios-image-inner">
            <img
              src="/images/recu3.png"
              alt="Sharing Job Offer"
              className="aios-image"
            />
          </div>
        </div>

        {/* RIGHT SIDE CONTENT */}
        <div className="aios-left">
          <p className="aios-subtitle">PUBLICATION</p>

          <h1 className="aios-title">
            <span className="aios-title-dark">Sharing a new</span>{" "}
            <span className="aios-title-highlight">job offer</span>
          </h1>

          <p className="aios-description">
            Integrate the ATS with the web environment, publish the position
            from the application to the career site and share it on job portals.
          </p>

          {/* Feature List */}
          <div className="aios-features">
            <div className="aios-feature-item">
              <FiCheckCircle className="aios-icon" />
              <span>Sharing positions on job portals</span>
            </div>

            <div className="aios-feature-item">
              <FiCheckCircle className="aios-icon" />
              <span>Integration to your own web environment</span>
            </div>
          </div>

          {/* Buttons */}
          <div className="aios-buttons">
            <button className="aios-btn-primary">Try it for free</button>
            <button className="aios-btn-secondary">Request demo</button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AIShareJobSection;
